import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlay} from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { playing } from '../redux/reducer/playerReducer';
import { setIndex } from '../redux/reducer/currentSong';
import { playin } from '../redux/reducer/playing';

function Card({index,title,image,artist}) {
  const dispatch = useDispatch();
  const handleClick = ()=>{
    dispatch(playing());
    dispatch(setIndex(index));
  }
  return (
    <>
        {/* <Link to={"/song/"+path} className="card m-2 col-lg-3"> */}
        {/* <div className="card m-2 col-lg-3" onClick={()=>{setCurrentSongIndex(index)}}> */}
        <div className="card m-2 col-lg-3" onClick={handleClick}>
          <img className="card-img-top" src={image} alt={title}/>
          <div className="card-body">
            <button className='play' onClick={()=>dispatch(playin())}><FontAwesomeIcon icon={faPlay}/> </button>
            <h6 className="card-title">{title}</h6>
            <p className="card-text">{artist}</p>
          </div>
        </div>
    </>
  )
}

export default Card